function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import ItemView from './itemView.js';
import { GalleryComponent } from '../galleryComponent';

var ItemContainer =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(ItemContainer, _GalleryComponent);

  function ItemContainer() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = ItemContainer.prototype;

  _proto.render = function render() {
    return React.createElement(ItemView, _extends({
      layout: "galleryItem",
      className: "image"
    }, this.props));
  };

  return ItemContainer;
}(GalleryComponent);

export default ItemContainer;